import { Controller } from 'lib_ts/enums/routing/controllers';
import { ToPythonRoutes } from 'lib_ts/enums/routing/routes/python';
import {
  IBuildHitRequest,
  IBuildHitResults,
} from 'lib_ts/interfaces/session-hits/i-hit-details';
import { BaseRESTService } from 'services/_base-rest.service';

export class PythonService extends BaseRESTService {
  private static instance: PythonService;
  static getInstance(): PythonService {
    if (!PythonService.instance) {
      PythonService.instance = new PythonService();
    }

    return PythonService.instance;
  }

  private constructor() {
    super({
      controller: Controller.Python,
    });
  }

  async buildHits(
    request: IBuildHitRequest
  ): Promise<IBuildHitResults | undefined> {
    return await this.post(
      {
        uri: ToPythonRoutes.BuildHits,
      },
      request
    );
  }
}
